export default {
  getProfile (state, payload) {
    state.profile = payload
  },
  addTotalNotification (state, payload) {
    state.total_notification += 1
  },
  cleanTotalNotification (state, payload) {
    state.total_notification = 0
  }
}



// WEBPACK FOOTER //
// ./src/store/module/profile/mutations.js